import axios from "axios";

export { maintenanceCarActions };

axios.defaults.withCredentials = true;

function maintenanceCarActions() {
  const baseUrl = ``;
    const tenantVal = `${process.env.REACT_APP_TENANT}`;
  return {
    getMaintenanceCar,
    exportDataMaintenanceCar,
    exportFileMaintenanceCarDataById,
    createMaintenanceCar,
    updateMaintenanceCar,
  };

  async function exportDataMaintenanceCar(
    plate?: String,
    vin?: String,
    maintenanceDateFrom?: any,
    maintenanceDateTo?: any
  ) {
    const exportAllDataMaintenanceCar = await axios.get(
      `${baseUrl}/masterdatavehicle/maintenance/excel`,
      {
        params: {
          plate: plate,
          vin: vin,
          maintenanceDateFrom: maintenanceDateFrom,
          maintenanceDateTo: maintenanceDateTo,
        },
        responseType: "arraybuffer",
        headers: { "Access-Control-Allow-Origin": true },
      }
    );

    return exportAllDataMaintenanceCar;
  }

  async function exportFileMaintenanceCarDataById(
    tenant: string,
    vehicleId?: number,
    maintenanceDateFrom?: any,
    maintenanceDateTo?: any
  ) {
    const exportFileById = await axios.get(
      `${baseUrl}/masterdatavehicle/maintenance/vehicle/${vehicleId}/excel`,

      {
        params: {
          tenant:tenant,
          maintenanceDateFrom: maintenanceDateFrom,
          maintenanceDateTo: maintenanceDateTo,
        },
        responseType: "arraybuffer",
        headers: { "Access-Control-Allow-Origin": true },
      }
    );

    return exportFileById;
  }

  async function getMaintenanceCar(
    tenant: String ,
    plate?: String,
    vin?: String,
    maintenanceDateFrom?: any,
    maintenanceDateTo?: any
  ) {
    const getAllMaintenanceCar = await axios.get(
      `${baseUrl}/masterdatavehicle/maintenance`,
      {
        params: {
          tenant:tenant,
          plate: plate,
          vin: vin,
          maintenanceDateFrom: maintenanceDateFrom,
          maintenanceDateTo: maintenanceDateTo,
        },
      }
    );

    return getAllMaintenanceCar;
  }

  async function createMaintenanceCar(tenant: string ,createMaintenanceCarObject: any) {
    const createNewMaintenanceCar = await axios.post(
      `${baseUrl}/masterdatavehicle/maintenance`,
      createMaintenanceCarObject,{params:{tenant:tenant}}
    );
    return createNewMaintenanceCar;
  }

  async function updateMaintenanceCar(
    tenant: string ,
    id: number,
    editMaintenanceCarObject: any
  ) {
    return await axios.put(
      `${baseUrl}/masterdatavehicle/maintenance/${id}`,
      editMaintenanceCarObject,{params:{tenant:tenant}}
    );
  }
}
